const UNSUPPORTED_LANGUAGES = ["elixir"];
const PERMISSION_REMEDIATION_LANGUAGES = "remediation_languages_fixes";

export { PERMISSION_REMEDIATION_LANGUAGES, UNSUPPORTED_LANGUAGES };
